<!--
 * @Title: 标题
 * @Description: 描述
 * @Author: xulongyong
 * @Date: 2023-09-10 11:12:29
 * @LastEditors: xulongyong
 * @LastEditTime: 2023-09-10 11:13:56
 * @FilePath: \vue-privilege-routing\src\pages\component\content\index.vue
-->
<template>
    <div>
       内容模组
    </div>
</template>

<script>
export default {
    data() {
        return {}
    }
}
</script>
